<template>
  <div>
    <div class="field is-horizontal is-block-touch">
      <div class="field-label has-text-left-touch">
        <label class="label">เจ้าของโครงการ</label>
      </div>
      <div class="field-body is-block is-flex-widescreen">
        <div class="field is-narrow">
          <table class="table is-narrow is-borderless">
            <tbody>
            <tr>
              <td style="width: 450px">
                <v-select class="is-fullwidth"
                          label="full_name"
                          :options="people"
                          :value="project.owner.title"
                          @input="(value) => changeMember(project.owner, value)"
                          placeholder="ระบุชื่อเจ้าของโครงการ"
                          :filterable="false"
                          @search="searchPeople"
                          required
                >
                  <p slot="no-options">พิมพ์ชื่อบุคลากร มศว เพื่อค้นหา...</p>
                </v-select>
                <input type="hidden"
                       name="owner[0][id]"
                       v-model="project.owner.id"
                />
                <input type="hidden"
                       name="owner[0][person_id]"
                       v-model="project.owner.person_id"
                /><input type="hidden"
                         name="owner[0][title]"
                         v-model="project.owner.title"
              />
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <td>
                <label class="flex items-center">
                  <span class="mr-2 w-24"> ตำแหน่ง</span>
                  <input type="text"
                         class="input"
                         name="owner[0][position]"
                         placeholder="ตำแหน่ง"
                         v-model="project.owner.position"
                  />
                </label>
              </td>
            <tr>
              <td>
                <label class="flex items-center">
                  <span class="mr-2 w-24"> อีเมล์</span>
                  <input type="text"
                         class="input"
                         name="owner[0][email]"
                         placeholder="อีเมล์"
                         v-model="project.owner.email"
                  />
                </label>
              </td>
            </tr>
            <tr>
              <td>
                <label class="flex items-center">
                  <span class="mr-2 w-24"> Line ID</span>
                  <input type="text"
                         class="input"
                         name="owner[0][line_id]"
                         placeholder="Line ID"
                         v-model="project.owner.line_id"
                  />
                </label>
              </td>
            </tr>
            <tr>
              <td>
                <label class="flex items-center">
                  <span class="mr-2 w-24"> เบอร์ติดต่อ</span>
                  <input type="text"
                         class="input"
                         name="owner[0][tel]"
                         placeholder="เบอร์ติดต่อ"
                         v-model="project.owner.tel"
                  />
                </label>

              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="field is-horizontal is-block-touch">
      <div class="field-label has-text-left-touch">
        <label class="label">ผู้ประสานงาน</label>
      </div>
      <div class="field-body is-block is-flex-widescreen">
        <div class="field is-narrow">
          <table class="table is-narrow is-borderless">
            <tbody>
            <tr>
              <td style="width: 450px">
                <v-select class="is-fullwidth"
                          label="full_name"
                          :options="people"
                          :value="project.coordinator.title"
                          @input="(value) => changeMember(project.coordinator, value)"
                          placeholder="ระบุชื่อผู้ประสานงาน"
                          :filterable="false"
                          @search="searchPeople"
                          required
                >
                  <p slot="no-options">พิมพ์ชื่อบุคลากร มศว เพื่อค้นหา...</p>
                </v-select>
                <input type="hidden"
                       name="coordinator[0][id]"
                       v-model="project.coordinator.id"
                />
                <input type="hidden"
                       name="coordinator[0][person_id]"
                       v-model="project.coordinator.person_id"
                /><input type="hidden"
                         name="coordinator[0][title]"
                         v-model="project.coordinator.title"
              />
              </td>
              <td>
                <input type="hidden"
                       name="coordinator[0][is_coordinator]"
                       value="1"
                />
              </td>
            </tr>
            <tr>
              <td>
                <label class="flex items-center">
                  <span class="mr-2 w-24"> ตำแหน่ง</span>
                  <input type="text"
                         class="input"
                         name="coordinator[0][position]"
                         placeholder="ตำแหน่ง"
                         v-model="project.coordinator.position"
                  />
                </label>
              </td>
            <tr>
              <td>
                <label class="flex items-center">
                  <span class="mr-2 w-24"> อีเมล์</span>
                  <input type="text"
                         class="input"
                         name="coordinator[0][email]"
                         placeholder="อีเมล์"
                         v-model="project.coordinator.email"
                  />
                </label>
              </td>
            </tr>
            <tr>
              <td>
                <label class="flex items-center">
                  <span class="mr-2 w-24"> Line ID</span>
                  <input type="text"
                         class="input"
                         name="coordinator[0][line_id]"
                         placeholder="Line ID"
                         v-model="project.coordinator.line_id"
                  />
                </label>
              </td>
            </tr>
            <tr>
              <td>
                <label class="flex items-center">
                  <span class="mr-2 w-24"> เบอร์ติดต่อ</span>
                  <input type="text"
                         class="input"
                         name="coordinator[0][tel]"
                         placeholder="เบอร์ติดต่อ"
                         v-model="project.coordinator.tel"
                  />
                </label>

              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
export default {
  data() {
    return {
      people: [],
      newMember
    }
  },
  props: {
    project: {type: Object, required: true},
  },

  created() {

  },

  methods: {
    changeMember(member, person) {
      if (member.title == person) {
        return;
      }
      member.person_id = null;

      if (this.isInternalPerson(person)) {
        member.person_id = person.person_id;
      } else {
        member.title = person;
      }

      this.$forceUpdate();
    },

    isInternalPerson(person) {
      return typeof person === 'object' && person != null;
    },

    searchPeople(search, loading) {
      loading(true);

      axios.get('api/people/?q=' + search).then((resp) => {
        this.people = resp.data;
        loading(false);
      });
    },

  }
}
</script>
